import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from '../../../../shared/components/dialog/dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AlertMessageComponent } from '../../../../shared/components/alert-message/alert-message.component';
import { TransactionService } from '../../services/transaction.service';

@Component({
  selector: 'app-email-resend-dialog',
  standalone: true,
  imports: [CommonModule, DialogComponent, ReactiveFormsModule, AlertMessageComponent],
  templateUrl: './email-resend-dialog.component.html',
})
export class EmailResendDialogComponent {
  @Input() show = false;
  @Input() recipientName: string | null = null;
  @Input() fileNumber: string | null = null;
  @Input() transactionId: number | null = null;
  @Input() showHeader: boolean = true;
  @Output() close = new EventEmitter<void>();
  @Output() confirmResend = new EventEmitter<void>();
  @Output() error = new EventEmitter<{ error?: any }>();

  constructor(private readonly transactionService: TransactionService) { }

  onCancel() {
    this.close.emit();
  }

  onConfirm() {
    if (this.transactionId) {
      this.transactionService.resendEmail(this.transactionId)
        .subscribe({
          next: () => {
            this.confirmResend.emit();
          },
          error: (errorResponse) => {
            this.error.emit(errorResponse?.error);
          }
        });

    }
  }
} 